import { BookOpenIcon, DumbbellIcon, type LucideIcon } from 'lucide-react';

export interface Pillar {
  icon: LucideIcon;
  tag: string;
  title: string;
  value: string;
  today: string;
  lead: string;
  items: string[];
}

export const pillars: Pillar[] = [
  {
    icon: BookOpenIcon,
    tag: 'Incluido 📚',
    title: 'Los 6 Tomos del Sistema "Sesión en Mano"',
    value: '59,90€',
    today: 'Hoy: Incluido',
    lead: 'Sesiones completas y más de 150 ejercicios y fichas para que nunca te falten propuestas.',
    items: [
      'TOMO 1 — Metodología y Planificación "Cero Estrés": organiza objetivos, recursos y semanas de trabajo. Incluye dos sesiones modelo completas y hojas reutilizables para concretar la planificación.',
      'TOMO 2 — Técnica Individual: 64 ejercicios de control, pase, conducción, regate, finalización e integración, con diagramas, correcciones y ajustes de dificultad. Incluye 12 sesiones estructuradas.',
      'TOMO 3 — Táctica y Juego Colectivo: 40 tareas y 16 sesiones para trabajar salida de balón, defensa coordinada, repliegue, transiciones y juego de posición. Incluye pizarras y recorridos para F7 y F11 según la base del grupo.',
      'TOMO 4 — Preparación Física con Balón: 24 tareas y 12 sesiones con montajes, turnos, esfuerzo, recuperación y ajustes según la respuesta del grupo.',
      'TOMO 5 — La Pizarra Maestra (Balón Parado): 36 fichas ofensivas y defensivas de córneres, faltas y saques de banda, con secuencias y alternativas. Incluye 12 sesiones de ensayo y aplicación.',
      'TOMO 6 — Gestión del Vestuario y Padres: 16 guiones de actuación y 10 hojas de gestión para reuniones, participación, comunicación, conflictos y seguimiento, además de mensajes adaptables y un caso de aplicación.'
    ]
  },
  {
    icon: DumbbellIcon,
    tag: 'Incluido 💪',
    title: 'Los 5 Bonos Estratégicos',
    value: '59,50€',
    today: 'Hoy: Incluido',
    lead: 'Los recursos que hacen que el sistema funcione desde el primer día.',
    items: [
      'Bono #1 — Plan de Arranque 7 Días: Siete pasos para organizar recursos, elegir el foco y preparar tu primera sesión, con hojas reutilizables.',
      'Bono #2 — Sesión Express 15 Minutos: Recursos para los días con poco tiempo o para complementar una sesión.',
      'Bono #3 — 30 Entrenamientos Listos para Aplicar: Sesiones organizadas con objetivos, tareas, tiempos y correcciones.',
      'Bono #4 — 30 Juegos Técnicos para Fútbol Formativo: Juegos y retos adaptados del Tomo 2, organizados por habilidad.',
      'Bono #5 — Mapa de Temporada de 36 Semanas: Planificación adaptable al calendario de tu equipo.'
    ]
  }
];
